import React, { useEffect, useRef } from 'react';

/**
 * Composant Modal simple sans dépendance externe
 * @param {Object} props
 * @param {boolean} props.isOpen - État d'ouverture/fermeture de la modal
 * @param {Function} props.onClose - Fonction appelée à la fermeture
 * @param {ReactNode} props.children - Contenu de la modal
 */
const Modal = ({ isOpen, onClose, children }) => {
  const modalRef = useRef(null);

  // Fermer la modal quand on clique en dehors
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    // Fermer la modal quand on appuie sur Escape
    const handleEscapeKey = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('keydown', handleEscapeKey);
      // Bloquer le scroll du body quand la modal est ouverte
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscapeKey);
      // Rétablir le scroll quand la modal est fermée
      document.body.style.overflow = 'auto';
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen p-4 text-center border border-gray-300  bg-opacity-50">
        <div 
          ref={modalRef}
          className="w-4xl p-6 overflow-hidden bg-white rounded-lg shadow-xl transform transition-all  border-2 border-blue-900"
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;